import React from 'react';
import { useStory } from './StoryContext';
import { BookOpenIcon, ChevronLeftIcon } from 'lucide-react';
export const Library = ({
  onBack
}: {
  onBack: () => void;
}) => {
  const books = [{
    id: '1',
    title: 'The Bunny in Space',
    author: 'You',
    coverImage: 'https://uploadthingy.s3.us-west-1.amazonaws.com/mrcRH7NYsgYJRNyWBFwjCv/Bunny_Space_2.png',
    createdAt: new Date('2025-05-03')
  }, {
    id: '2',
    title: 'Dragon in the Playground',
    author: 'You',
    coverImage: 'https://uploadthingy.s3.us-west-1.amazonaws.com/1UgkqW25aMoX5uxvN1r3iE/Dragon.png',
    createdAt: new Date('2025-05-08')
  }, {
    id: '3',
    title: 'The Underwater Bakery',
    author: 'You',
    coverImage: 'https://uploadthingy.s3.us-west-1.amazonaws.com/sjq8LbrztXsdjKx192qSdd/ChatGPT_Image_May_17%2C_2025_at_10_29_20_AM.png',
    createdAt: new Date('2025-05-20')
  }];
  return <div className="flex-1 flex flex-col bg-[#FFFBF6] overflow-hidden" data-id="element-660">
      {/* Header */}
      <div className="bg-white shadow-sm border-b border-[#E5C1A9] p-4" data-id="element-661">
        <div className="max-w-7xl mx-auto flex items-center" data-id="element-662">
          <button onClick={onBack} className="mr-4 p-2 hover:bg-[#FFFBF6] rounded-full transition-colors" data-id="element-663">
            <ChevronLeftIcon size={24} className="text-[#6B4B3E]" data-id="element-664" />
          </button>
          <div data-id="element-665">
            <h1 className="text-2xl font-bold text-[#6B4B3E]" data-id="element-666">
              My Story Library
            </h1>
            <p className="text-sm text-[#6B4B3E]/75" data-id="element-667">
              Your personal collection of magical stories
            </p>
          </div>
        </div>
      </div>
      {/* Content */}
      <div className="flex-1 p-8 overflow-auto" data-id="element-668">
        <div className="max-w-7xl mx-auto" data-id="element-669">
          <div className="grid grid-cols-1 md:grid-cols-3 gap-8" data-id="element-670">
            {books.map(book => <div key={book.id} className="bg-white rounded-xl shadow-lg overflow-hidden hover:shadow-xl transition-shadow duration-300" data-id="element-671">
                <div className="aspect-[4/3] relative" data-id="element-672">
                  <img src={book.coverImage} alt={book.title} className="w-full h-full object-cover" data-id="element-673" />
                </div>
                <div className="p-6" data-id="element-674">
                  <h3 className="text-xl font-bold text-[#6B4B3E] mb-2" data-id="element-675">
                    {book.title}
                  </h3>
                  <p className="text-[#6B4B3E]/75 mb-2" data-id="element-676">by: {book.author}</p>
                  <p className="text-[#6B4B3E]/75 mb-4" data-id="element-677">
                    Date:{' '}
                    {book.createdAt.toLocaleDateString('en-US', {
                  month: 'long',
                  day: 'numeric',
                  year: 'numeric'
                })}
                  </p>
                  <button className="w-full bg-[#D4A088] text-white px-4 py-2 rounded-full hover:bg-[#C28B73] transition-colors flex items-center justify-center cursor-not-allowed opacity-80" disabled data-id="element-678">
                    Coming Soon!
                  </button>
                </div>
              </div>)}
          </div>
        </div>
      </div>
    </div>;
};